import React, { ChangeEvent, useState } from "react";
import {
  FormControl,
  Grid,
  IconButton,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { ICredentialsUrbanoProps } from "../../interfaces/configuration";
import { SimpleFormInput } from "./SimpleFormInput";
import { showInputErrors } from "../../utils/credentials";

const CredentialsUrbano = ({
  values,
  setValues,
  errors,
}: ICredentialsUrbanoProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const baseInfo = {
    values,
    setValues,
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <SimpleFormInput
          inputTitle="Id de cliente"
          placeholder="Ingresar el id de cliente"
          valueName="urbano_client_id"
          errors={errors.urbano_client_id}
          {...baseInfo}
          autoFocus
        />
      </Grid>
      <Grid item xs={6}>
        <FormControl size="small" fullWidth>
          <Typography className="f-s-14 m-b-10">Contraseña</Typography>
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            placeholder="Ingresar contraseña"
            value={values.urbano_password}
            error={errors.urbano_password?.length > 0}
            onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) =>
              setValues({ ...values, urbano_password: value.trim() })
            }
            className="f-s-14"
            endAdornment={
              <IconButton onClick={() => setShowPassword(!showPassword)}>
                <span className="material-symbols-rounded">
                  {showPassword ? "visibility_off" : "visibility"}
                </span>
              </IconButton>
            }
          />
          {errors.urbano_password?.length > 0 &&
            showInputErrors(errors.urbano_password)}
        </FormControl>
      </Grid>
      <Grid item md={6}>
        <SimpleFormInput
          inputTitle="IVA"
          placeholder={"21"}
          valueName="iva"
          errors={errors.iva}
          endAdornment="%"
          {...baseInfo}
        />
      </Grid>
    </Grid>
  );
};

export default CredentialsUrbano;
